import type { SxProps, Theme } from '@mui/material';
import React, { ReactNode } from 'react';
import Alert from '../components/alert/Alert';
import { V } from '../Layout';

export default function FormModalInfoAlert({
    descriptionToken = '',
    i18nValues = {},
    children = undefined,
    title = undefined,
    sx = {},
    alertSx = {},
    titleSx
}: {
    descriptionToken?: string;
    i18nValues?: { [key: string]: string | number | boolean };
    children?: ReactNode;
    title?: string;
    sx?: SxProps;
    alertSx?: SxProps<Theme>;
    titleSx?: SxProps<Theme>;
}) {
    return (
        <V sx={{ pt: 1, pr: 1, pl: 2, ...sx }}>
            <Alert
                title={title}
                descriptionToken={descriptionToken}
                children={children}
                i18nValues={i18nValues}
                sx={{ ...alertSx }}
                titleSx={{ ...titleSx }}
            />
        </V>
    );
}
